<template>
    <div>
        <campaign-template-table ref="table" :url="indexUrl">
            <template v-slot:buttons>
                <button class="btn btn-purple" v-if="canCreate" @click="addCampaignTemplate">
                    <i class="far fa-file"></i>
                </button>
            </template>
        </campaign-template-table>
        <dialog-form-wrapper></dialog-form-wrapper>
    </div>
</template>

<script>
  import CampaignTemplateTable from '../../components/campaign-template/table';
  import eventBus from '../../event-bus';
  import DialogFormWrapper from './dialog-form-wrapper';

  export default {
    components: {
      CampaignTemplateTable,
      DialogFormWrapper
    },

    props: {
      indexUrl: null,
      createUrl: null,
      canCreate: {
        type: Boolean,
        default: false
      },
    },
    methods: {
      /**
       * @event show-add-campaign-template-dialog
       */
      addCampaignTemplate() {
        eventBus.$emit('show-add-campaign-template-dialog', this.createUrl);
      },

      /**
       * @return {undefined}
       */
      refresh() {
        this.$refs.table.refresh();
      }
    },

    created() {
      eventBus.$on('refresh-campaign-template-table', this.refresh);
    },

    beforeDestroy() {
      eventBus.$off('refresh-campaign-template-table', this.refresh);
    }
  }
</script>
